import { CircularProgress } from "@material-ui/core";
import { Text } from "components/Typography/text.styled";
import { BannerComponent } from "components/banners/banner.component";
import { LoggedOutPageContainer } from "components/pageLayouts/pageLayouts.styled";
import { PageContainer } from "components/designV2/layout/grid";
import { Color } from "config/colors";
import { FontFamily, FontSize } from "config/font";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Page } from "web-apps/company/components/schedule/components/views/shared/schedule.styled";
import { TimeReports } from "web-apps/company/components/timeReportsV2/timeReports.component";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";

export const TimeReportsV2Page = () => {
  const [companyState] = useCompanyStore();
  const [authState] = useCompanyStore();
  const { t } = useTranslation();
  return (
    <Page>
      <TimeReportsPageContainer>
        {authState.isLoading || companyState.isLoading ? (
          <LoggedOutPageContainer>
            <CircularProgress />
          </LoggedOutPageContainer>
        ) : (
          <>
            {companyState.company?.verified ? (
              <TimeReports />
            ) : (
              <BannerComponent
                icon="clock"
                backgroundColor={Color.ChampagnePink}
                fill={Color.Destructive}
              >
                <Text
                  fontSize={FontSize.Large}
                  fontFamily={FontFamily.MontserratSemiBold}
                  color={Color.Destructive}
                >
                  {t("GigsCompany.UnverifiedAccount")}
                </Text>
                <Text>{t("GigsCompany.UnverifiedAccountDetails")}</Text>
              </BannerComponent>
            )}
          </>
        )}
      </TimeReportsPageContainer>
    </Page>
  );
};

const TimeReportsPageContainer = styled(PageContainer)`
  margin-top: 0;
`;
